import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Pagination } from '@src/api/types/pagination';
import { IndexRequest } from '@src/api/types/shared/request';

export type TenantCompanyUser = {
  id: number;
  created_on: string;
  family_name: string;
  first_name: string;
  company_name: string;
  company_role_name: string;
  email: string;
  status: boolean;
  authenticated: boolean;
};

export type TenantCompanyUserIndexResponse = {
  data: TenantCompanyUser[];
  pagination: Pagination;
};

export type CompanyUserShowResponse = {
  id: number;
  company_name: string;
  company_role_id: string;
  family_name: string;
  first_name: string;
  family_name_kana: string;
  first_name_kana: string;
  birthday: string;
  email: string;
  expires_at: string;
  enabled: boolean;
  can_resend_invitation: boolean;
};

export type CompanyUserUpdateRequest = {
  company_user: {
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    birthday: string;
    company_role_id: string;
    enabled?: boolean;
  };
};

export type CompanyUserUpdateResponse = unknown;

export type CompanyUserUpdateErrorResponse = {
  company_user: {
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    birthday: string[];
    company_role_id: string[];
    enabled: string[];
  };
};

export type SuggestEmailRequest = {
  family_name: string;
  first_name: string;
  suggested_email: string;
};

export type SuggestEmailResponse = unknown;

export type SuggestEmailErrorResponse = {
  suggested_email: string[];
};

export const TenantCompanyUserApiClient = {
  index: async (params: IndexRequest = {}): Promise<ApiResult<TenantCompanyUserIndexResponse>> => {
    return await axiosClient.get('/tenant/company-users', { params });
  },
  show: async (id: number): Promise<ApiResult<CompanyUserShowResponse>> => {
    return await axiosClient.get(`/tenant/company-users/${id}`);
  },
  update: async (
    id: number,
    data: CompanyUserUpdateRequest,
  ): Promise<ApiResult<CompanyUserUpdateResponse, CompanyUserUpdateErrorResponse>> => {
    return await axiosClient.put(`/tenant/company-users/${id}`, data);
  },
  delete: async (id: number): Promise<ApiResult> => {
    return await axiosClient.delete(`/tenant/company-users/${id}`);
  },
  sendSuggestion: async (
    id: number,
    data: SuggestEmailRequest,
  ): Promise<ApiResult<SuggestEmailResponse, SuggestEmailErrorResponse>> => {
    return await axiosClient.put(`/tenant/company-users/${id}/email/suggestion`, data);
  },
};
